module.exports = __webpack_public_path__ + "static/img/sence-6-map.26db90a.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sence-6-map.png
// module id = 4gNg
// module chunks = 1